var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "master_svg0_2_4530"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#master_svg0_2_4530)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.999918937683105,
    cy: 10.999918937683105,
    rx: 9.166666984558105,
    ry: 9.166666984558105,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M8.848959921875,7.3333740234375C8.848959921875,7.5098160234375,8.781119921875,7.6795040234375005,8.659479921875,7.8073240234375L8.020089921875,8.4792040234375L15.583439921875,8.4792040234375C15.963169921875,8.4792040234375,16.270969921875,8.7870140234375,16.270969921875,9.1667040234375C16.270969921875,9.5464040234375,15.963169921875,9.8542040234375,15.583439921875,9.8542040234375L6.844321921875,9.8542040234375Q6.270217921875,9.8542040234375,6.043965721875,9.3265640234375Q5.817712921875,8.7989240234375,6.213486921875,8.3830440234375L7.663429921875,6.8594280234375C7.793199921875,6.7230626234375,7.973209921875,6.6458740234375,8.161459921875,6.6458740234375C8.541149921875,6.6458740234375,8.848959921875,6.9536780234375,8.848959921875,7.3333740234375Z",
    fillRule: "evenodd",
    fill: "#FF4747",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-1,0,0,-1,32.07666015625,30.708251953125)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.925620078125,16.0416259765625C18.925620078125,16.2180679765625,18.857780078125,16.3877559765625,18.736140078125,16.5155759765625L18.096750078124998,17.1874559765625L25.660100078124998,17.1874559765625C26.039830078125,17.1874559765625,26.347630078125,17.4952659765625,26.347630078125,17.8749559765625C26.347630078125,18.2546559765625,26.039830078125,18.5624559765625,25.660100078124998,18.5624559765625L16.920982078125,18.5624559765625Q16.346878078125,18.5624559765625,16.120625878125,18.0348159765625Q15.894373078125,17.5071759765625,16.290147078125,17.0912959765625L17.740090078125,15.5676799765625C17.869860078125,15.4313145765625,18.049870078125,15.3541259765625,18.238120078125,15.3541259765625C18.617810078125,15.3541259765625,18.925620078125,15.6619299765625,18.925620078125,16.0416259765625Z",
    fillRule: "evenodd",
    fill: "#FF4747",
    fillOpacity: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "media/icon.442d8c22.svg";
export { ForwardRef as ReactComponent };